/**
 * Provide common utils methods and fields
 * for sticky elements (header/footer)
 */

define([], ()=> {
    // is used to provide unique eventName
    // to subscribe/unsubscribe to global events
    const eventNamePostfix = 'sticky';
    let eventNameId = 0;

    return (params)=> {
        // EVENTS
        // from params
        const phoneMediaBreakpoint = params.phoneMediaBreakpoint;
        const _eventNamePostfix = eventNamePostfix + (eventNameId++);// generates unique
        const $scope = params.$scope;
        const refreshPosition = params.refreshPosition;
        const $scrollElement = params.$scrollElement;
        const resetPositionToDefault = params.resetPositionToDefault;

        // others
        const $window = $(window);

        const mediaQuery = window.matchMedia(`(max-width: ${phoneMediaBreakpoint}px)`);


        // STICKY POSITION

        // APPLY "FIXED" HEADER ONLY FOR MOBILE DEVICES
        // media query change
        function breakpointReached(_mediaQuery) {
            if (_mediaQuery.matches) {// < break
                $window.on(`resize.${_eventNamePostfix}`, refreshPosition);
                $scrollElement.on(`scroll.${_eventNamePostfix}`, refreshPosition);
                refreshPosition();
            } else {// >= break
                $window.off(`resize.${_eventNamePostfix}`);
                $scrollElement.off(`scroll.${_eventNamePostfix}`);
                resetPositionToDefault();
            }
        }

        // INIT
        breakpointReached(mediaQuery);
        // make sure sticky is positioned well after all $digest cycles etc.
        setTimeout(()=> {
            breakpointReached(mediaQuery);
        }, 100);

        // EVENTS
        mediaQuery.addListener(breakpointReached);

        // remove listeners on $scope destroying
        $scope.$on('$destroy', ()=> {
            $window.off('resize.stickyheader');
            $scrollElement.off('scroll.stickyheader');
            mediaQuery.removeListener(breakpointReached);
        });
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/pagestructure/StickyCommonUtils.js
 **/